/* ==========================================================================
   Découverte — Product Page JS
   Progressive enhancement: the buy-box form is a real <form action="/cart/add">,
   so Add to Cart still works with JS disabled (full page post + redirect to cart).
   With JS enabled: AJAX add-to-cart, live color-swatch variant switching,
   quantity stepper, mobile gallery dots, sticky mobile bar, and lazy-loaded
   product recommendations.
   ========================================================================== */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    // Fallback simple formatter; Shopify.formatMoney (theme.js) is used if already present.
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function initProductSection(root) {
    var form = root.querySelector('[data-dcv-buybox] form, #dcv-product-form');
    if (!form) return;

    var variantsScript = root.querySelector('[data-dcv-variants]');
    var variants = [];
    try {
      variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    } catch (e) {
      variants = [];
    }

    var variantIdInput = form.querySelector('[data-dcv-variant-id]');
    var qtyInput = root.querySelector('[data-dcv-qty-input]');
    var qtyMinus = root.querySelector('[data-dcv-qty-minus]');
    var qtyPlus = root.querySelector('[data-dcv-qty-plus]');
    var ctaPrice = root.querySelector('[data-dcv-cta-price]');
    var ctaButton = root.querySelector('[data-dcv-add-to-cart]');
    var statusEl = root.querySelector('[data-dcv-status]');
    var optionButtons = root.querySelectorAll('[data-dcv-option-select]');
    var gallery = root.querySelector('[data-dcv-gallery]');
    var stickyBar = root.querySelector('[data-dcv-sticky-bar]');
    var stickySwatch = root.querySelector('[data-dcv-sticky-swatch]');
    var stickyPrice = root.querySelector('[data-dcv-sticky-price]');
    var stickyAddBtn = root.querySelector('[data-dcv-sticky-add]');

    function currentVariantId() {
      return variantIdInput ? variantIdInput.value : null;
    }

    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    // ---- Quantity stepper ----
    function setQty(delta) {
      if (!qtyInput) return;
      var val = parseInt(qtyInput.value, 10) || 1;
      val = Math.max(1, val + delta);
      qtyInput.value = val;
    }
    if (qtyMinus) {
      qtyMinus.addEventListener('click', function (e) {
        e.preventDefault();
        setQty(-1);
      });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function (e) {
        e.preventDefault();
        setQty(1);
      });
    }
    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        qtyInput.value = qtyInput.value.replace(/[^0-9]/g, '');
      });
      qtyInput.addEventListener('change', function () {
        var val = parseInt(qtyInput.value, 10);
        if (!val || val < 1) qtyInput.value = 1;
      });
    }

    // ---- Option selection (color swatches + any other option, e.g. Size) → variant switching ----
    function selectOption(optionIndex, value) {
      var active = findVariant(currentVariantId());
      var targetOptions = active ? active.options.slice() : [];
      targetOptions[optionIndex] = value;

      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var isMatch = true;
        for (var j = 0; j < targetOptions.length; j++) {
          if (j === optionIndex) continue;
          if (v.options[j] !== targetOptions[j]) { isMatch = false; break; }
        }
        if (isMatch && v.options[optionIndex] === value) { match = v; break; }
      }
      if (!match) return;

      if (variantIdInput) variantIdInput.value = match.id;

      var label = root.querySelector('[data-dcv-option-label="' + optionIndex + '"]');
      if (label) label.textContent = value;

      var priceText = formatMoney(match.price);
      if (ctaPrice) ctaPrice.textContent = priceText;
      if (stickyPrice) stickyPrice.textContent = priceText;

      if (ctaButton) {
        ctaButton.disabled = !match.available;
      }
      if (statusEl) { statusEl.hidden = true; statusEl.textContent = ''; }

      optionButtons.forEach(function (btn) {
        if (parseInt(btn.getAttribute('data-option-index'), 10) !== optionIndex) return;
        var isSelected = btn.getAttribute('data-value') === value;
        btn.classList.toggle('is-selected', isSelected);
        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        if (isSelected && stickySwatch && btn.classList.contains('dcv-swatch')) {
          var bg = window.getComputedStyle(btn).backgroundImage;
          var bgColor = window.getComputedStyle(btn).backgroundColor;
          stickySwatch.style.backgroundImage = bg !== 'none' ? bg : '';
          stickySwatch.style.backgroundColor = bgColor;
        }
      });

      // Use featured_media (not featured_image) to find the matching gallery slide —
      // featured_media.id shares the same ID space as product.media (rendered as
      // data-media-id below), while featured_image.id is a separate legacy image ID
      // that doesn't reliably match it.
      if (match.featured_media && gallery) {
        var mediaItem = gallery.querySelector('[data-media-id="' + match.featured_media.id + '"]');
        if (mediaItem && typeof mediaItem.scrollIntoView === 'function') {
          mediaItem.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      }

      document.dispatchEvent(new CustomEvent('dcv:variant-change', { detail: { variant: match }, bubbles: true }));
    }

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var optionIndex = parseInt(btn.getAttribute('data-option-index'), 10);
        selectOption(optionIndex, btn.getAttribute('data-value'));
      });
    });

    // ---- Add-to-cart success feedback: checkmark + flying image + native cart drawer ----
    var addedResetTimeout = null;

    function sourceButton() {
      if (stickyBar && !stickyBar.hidden && stickyAddBtn) return stickyAddBtn;
      return ctaButton;
    }

    function flyingImageUrl(activeVariant) {
      if (activeVariant && activeVariant.featured_image && activeVariant.featured_image.src) {
        return activeVariant.featured_image.src;
      }
      var img = gallery && gallery.querySelector('.dcv-gallery__img');
      return img ? img.currentSrc || img.src : null;
    }

    function flyToCart(fromEl, imageUrl) {
      var cartIcon = document.querySelector('.header-actions__cart-icon, [data-cart-icon], a[href="/cart"]');
      if (!cartIcon || !fromEl || !imageUrl) return;

      var sourceRect = fromEl.getBoundingClientRect();
      var destRect = cartIcon.getBoundingClientRect();
      var size = 48;
      var startX = sourceRect.left + sourceRect.width / 2 - size / 2;
      var startY = sourceRect.top + sourceRect.height / 2 - size / 2;
      var endX = destRect.left + destRect.width / 2 - size / 2;
      var endY = destRect.top + destRect.height / 2 - size / 2;

      var el = document.createElement('div');
      el.className = 'dcv-fly';
      el.style.backgroundImage = 'url(' + imageUrl + ')';
      el.style.left = startX + 'px';
      el.style.top = startY + 'px';
      el.style.setProperty('--dcv-fly-dx', (endX - startX) + 'px');
      el.style.setProperty('--dcv-fly-dy', (endY - startY) + 'px');
      document.body.appendChild(el);

      var cleanup = function () {
        el.remove();
      };
      el.addEventListener('animationend', cleanup);
      setTimeout(cleanup, 900); // safety fallback if animationend doesn't fire
    }

    function playAddedFeedback(activeVariant, qty) {
      var btn = sourceButton();
      if (addedResetTimeout) clearTimeout(addedResetTimeout);

      [ctaButton, stickyAddBtn].forEach(function (b) {
        if (b) b.dataset.added = 'true';
      });

      flyToCart(btn, flyingImageUrl(activeVariant));

      addedResetTimeout = setTimeout(function () {
        [ctaButton, stickyAddBtn].forEach(function (b) {
          if (b) b.removeAttribute('data-added');
        });
      }, 1400);

      // Notify the parent theme (Horizon-based) so its own cart icon bubble and
      // cart drawer update/open exactly as they do for native product forms.
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: null,
          sourceId: 'dcv-product-form-' + root.id,
          data: {
            source: 'product-form-component',
            itemCount: qty,
            productId: activeVariant ? String(activeVariant.product_id) : undefined
          }
        }
      }));
    }

    // ---- Add to cart (AJAX with full-page fallback) ----
    function submitAddToCart(e) {
      if (e) e.preventDefault();
      if (!window.fetch) return true; // let native form submission happen

      if (ctaButton) ctaButton.disabled = true;
      if (statusEl) {
        statusEl.hidden = false;
        statusEl.removeAttribute('data-state');
        statusEl.textContent = 'Adding…';
      }

      var qty = parseInt((qtyInput && qtyInput.value) || '1', 10) || 1;
      var activeVariant = findVariant(currentVariantId());

      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) {
            var message = (result.data && result.data.description) || 'Couldn\'t add this item to your bag.';
            throw new Error(message);
          }
          if (statusEl) {
            statusEl.textContent = 'Added to your bag.';
            statusEl.setAttribute('data-state', 'success');
          }
          playAddedFeedback(activeVariant, qty);
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { item: result.data } }));
          document.dispatchEvent(new CustomEvent('dcv:added-to-cart', { bubbles: true, detail: { item: result.data } }));
        })
        .catch(function (err) {
          if (statusEl) {
            statusEl.hidden = false;
            statusEl.setAttribute('data-state', 'error');
            statusEl.textContent = err.message || 'Something went wrong. Please try again.';
          }
        })
        .finally(function () {
          var active = findVariant(currentVariantId());
          if (ctaButton) ctaButton.disabled = active ? !active.available : false;
        });
    }
    form.addEventListener('submit', submitAddToCart);
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else submitAddToCart();
      });
    }

    // ---- Sticky mobile bar visibility ----
    if (stickyBar && form && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            stickyBar.hidden = entry.isIntersecting;
          });
        },
        { rootMargin: '0px 0px -20% 0px', threshold: 0 }
      );
      observer.observe(form.querySelector('[data-dcv-add-to-cart]') || form);
    }

    // ---- Mobile gallery dots ----
    if (gallery) {
      var dotsWrap = root.querySelector('[data-dcv-gallery-dots]');
      var items = gallery.querySelectorAll('.dcv-gallery__item');
      if (dotsWrap && items.length > 1) {
        items.forEach(function (_, i) {
          var dot = document.createElement('div');
          dot.className = 'dcv-gallery-dots__dot' + (i === 0 ? ' is-active' : '');
          dotsWrap.appendChild(dot);
        });
        var dotEls = dotsWrap.querySelectorAll('.dcv-gallery-dots__dot');
        var scheduled = false;
        gallery.addEventListener('scroll', function () {
          if (scheduled) return;
          scheduled = true;
          window.requestAnimationFrame(function () {
            var index = Math.round(gallery.scrollLeft / gallery.clientWidth);
            dotEls.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
            scheduled = false;
          });
        });
      }
    }
  }

  // ---- Related products (lazy-loaded via Shopify recommendations endpoint) ----
  function initRelatedSection(root) {
    var url = root.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-dcv-related]');
        if (fresh && fresh.innerHTML.trim() !== '') {
          root.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () { /* fail silently, section stays empty */ });
  }

  function init() {
    document.querySelectorAll('.dcv-product').forEach(initProductSection);
    document.querySelectorAll('[data-dcv-related]').forEach(initRelatedSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (section.querySelector('.dcv-product')) section.querySelectorAll('.dcv-product').forEach(initProductSection);
    var related = section.querySelector('[data-dcv-related]');
    if (related) initRelatedSection(related);
  });
})();
